import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { format } from 'date-fns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Componente para exibir relógio na barra inferior
const ClockWidget = () => {
  const [time, setTime] = useState(new Date());
  const [config, setConfig] = useState({
    formato24h: true,
    exibirSegundos: false
  });
  
  // Carregar configurações
  useEffect(() => {
    const loadConfig = () => {
      const savedConfig = localStorage.getItem('painelChamada_configCompleta');
      if (savedConfig) {
        try {
          const parsedConfig = JSON.parse(savedConfig);
          if (parsedConfig.horario) {
            setConfig(parsedConfig.horario);
          }
        } catch (error) {
          console.error('Erro ao carregar configurações do relógio:', error);
        }
      }
    };
    
    loadConfig();
    
    // Atualizar o relógio a cada segundo
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);
    
    // Monitorar alterações nas configurações
    const configObserver = () => {
      window.addEventListener('storage', (event) => {
        if (event.key === 'painelChamada_configCompleta') {
          loadConfig();
        }
      });
    };
    
    configObserver();
    
    return () => {
      clearInterval(timer);
      window.removeEventListener('storage', configObserver);
    };
  }, []);
  
  // Formatar a hora com base nas configurações
  const getFormattedTime = () => {
    if (config.formato24h) {
      return config.exibirSegundos 
        ? format(time, 'HH:mm:ss')
        : format(time, 'HH:mm');
    } else {
      return config.exibirSegundos 
        ? format(time, 'hh:mm:ss a')
        : format(time, 'hh:mm a');
    }
  };
  
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <AccessTimeIcon sx={{ mr: 2, fontSize: 28 }} />
        <Typography variant="h3" sx={{ fontWeight: 'light' }}>
          {getFormattedTime()}
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ mt: 1, fontSize: '0.8rem' }}>
        HORÁRIO DE BRASÍLIA
      </Typography>
    </Box>
  );
};

export default ClockWidget; 